import { useTranslation } from "react-i18next";
import { NS } from "@core/libs/i18n/namespaces";
import type documents from "@core/locales/en/documents.json";

type RecursiveKeyOf<TObj extends object> = {
  [K in keyof TObj & string]: TObj[K] extends object
    ? `${K}.${RecursiveKeyOf<TObj[K]>}`
    : K;
}[keyof TObj & string];

type PdfKeys = RecursiveKeyOf<(typeof documents)["pdf"]>;

export function usePdfTranslate() {
  const { t: baseT } = useTranslation(NS.DOCUMENTS);

  const t = (key: PdfKeys) => baseT(`pdf.${key}`) as string;

  return { t };
}
